import { useQuery } from '@apollo/client';
import {
  getCookieValue,
  getHeaderValue,
  Loader,
  fetchApi
} from '@nile/components';
import { AccountClient, GET_USER_TFA_DETAIL } from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { Button } from '@superops/ui-design-system';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

const TFAConfigureParent = styled.div`
  .configure-steps {
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
  }

  .configure-steps:not(:last-child) {
    margin-bottom: 12px;
  }

  .or-block {
    margin-left: 48px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
  }

  .secret-key-block {
    background: #f4f5f7;
    font-size: 14px;
    margin-left: 48px;
    color: #2500ff;
    padding: 14px 12px;
    font-weight: 500;
  }

  .verification-code-input-block {
    margin-right: 24px;
    min-width: 300px;
    height: 38px;
    border: 1px solid #d4d4d4;
    border-radius: 4px;
    outline: none;
  }
`;

const TFAConfigContainer = (props) => {
  const { loader, authenticationVerifiedToken } = props;
  const [tfaSecretKey, setTfaSecretKey] = useState('');
  const [value, setValue] = useState('');
  const [isTfaDetailsGenerated, setIsTfaDetailsGenerated] = useState(false);
  const [qrCode, setQr] = useState(null);
  useQuery(GET_USER_TFA_DETAIL, {
    client: AccountClient,
    skip: props.history?.location?.pathname === '/configurenewtfa',
    onCompleted({ getCurrentUserTfaDetail }) {
      // if (getCurrentUserTfaDetail) {
      setIsTfaDetailsGenerated(true);
      // }
      // Redirect if already configured
      // if (getCurrentUserTfaDetail) {
      //   props.history.push('/');
      // }
    }
  });

  function handleChange(e) {
    setValue(e.target.value);
  }

  const fetchTFASecretKey = async () => {
    const verifyToken = authenticationVerifiedToken;
    const formData = new FormData();
    formData.append('passcode', value);
    formData.append('authenticationVerifiedToken', verifyToken);

    const requestOptions = {
      method: 'POST',
      headers: getHeaderValue(),
      body: formData,
      credentials: 'include'
    };
    try {
      const response = await fetchApi(
        `${envConfig.loginRoot}/user/generatetfa`,
        requestOptions
      );
      const data = await response.json();
      if (props.history?.location?.pathname === '/configurenewtfa') {
        setIsTfaDetailsGenerated(true);
      }
      setTfaSecretKey(data.authenticatorSecretKey);
    } catch (err) {
      new Error(err);
    }
  };

  useEffect(() => {
    fetchTFASecretKey();
  }, []);

  const handleEnableTFA = () => {
    props.handleEnableTFA(value);
  };

  return (
    <TFAConfigureParent>
      <div className="configure-steps">
        <FormattedMessage id="admin.myprofile.security.downloadApp" />
      </div>
      <div className="configure-steps">
        {' '}
        <FormattedMessage id="admin.myprofile.security.scanQR" />
      </div>
      <div className="flex-row flex-align-center">
        <div className="flex-item-fixed">
          {isTfaDetailsGenerated ? (
            <img
              src={`${localStorage?.getItem('apiDomain') +
                envConfig.loginRoot}/user/generatetfaqr?authenticationVerifiedToken=${encodeURIComponent(
                authenticationVerifiedToken
              )}`}
              alt="qr code"
            />
          ) : (
            <Loader />
          )}
        </div>
        <div className="flex-item-fixed or-block">
          <div>
            <FormattedMessage id="admin.myprofile.security.OR" />
          </div>
        </div>
        <div className="flex-item-fixed secret-key-block">{tfaSecretKey}</div>
      </div>
      <div className="configure-steps">
        <FormattedMessage id="admin.myprofile.security.verificationCode" />
      </div>
      <div className="flex-row flex-align-center">
        <div className="flex-item-fixed">
          <input
            type="password"
            value={value}
            onChange={handleChange}
            className="verification-code-input-block"
          />
        </div>
        <div className="flex-item-balloon">
          <Button
            id="tfaVerificationEnable"
            loading={loader}
            primary
            onClick={handleEnableTFA}
          >
            <FormattedMessage id="admin.myprofile.security.verify" />
          </Button>
        </div>
      </div>
    </TFAConfigureParent>
  );
};

export default withRouter(TFAConfigContainer);
